import angular from 'angular';

import DateExtended from "serviceJs/date.service.ts";

import '../../../../services/orders';

angular.module('folkeuni').component('customerOrderList', {
  templateUrl: '/shop-dist/templates/customer-order-list.html?c=' + window.cacheBurst,
  transclude: false,
  bindings: {
    guid: '=',
    orderId: '='
  },

  controller: function (Orders, $scope, $timeout) {

    var $ctrl = this;
    $ctrl.counter = 0;
    $ctrl.allLoaded = false;
    $ctrl.promisesArray = [];
    $ctrl.loading = true;
    $ctrl.lastLoaded = 0;
    $ctrl.products = [];
    $ctrl.orders = [{
      id: null,
      createdDate: "",
      lineCount: 2,
      status: "",
      totalAmountNotFormatted: 1,
      transactionId: "",
      customer: [{
        email: ""
      }]
    }];
    $ctrl.orderlines = [];
    $ctrl.orderDetailView = function (order) {
      $ctrl.guid = order.guid;
      $ctrl.orderId = order.id;
    }

    function dynamicSort(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (b, a) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    }

    $ctrl.loadMore = function () {
      $ctrl.fetchOrder();
    }

    $ctrl.fetchOrder = function () {
      $ctrl.loading = true;
      var currentLimit;
      $ctrl.lastLoaded = $ctrl.counter;

      if($ctrl.counter + 25 > $ctrl.orders.length)
      { 
        $ctrl.counter = $ctrl.orders.length;
        $ctrl.allLoaded = true;
      }
      else { 
        $ctrl.counter = $ctrl.counter + 25;
      }

      var orderDetailPromises = [];

      for (var i = $ctrl.lastLoaded; $ctrl.counter > i; i++) {
        var currentOrder = $ctrl.orders[i];

        orderDetailPromises.push(Orders.getOrderByIdAndGuid(currentOrder.id, currentOrder.guid));
  
      };

      Promise.all(orderDetailPromises).then((orderDetails) => {
        const ordersObj = $ctrl.orders;
        ordersObj.map(function (currentOrder) {
          orderDetails.map(function (currentOrderDetail) {
            if (currentOrder.id == currentOrderDetail.id) {
              currentOrderDetail.lines.map(function (orderline) {
                orderline.guid = currentOrder.guid;
                orderline.id = currentOrder.id;

                orderline.startDateFormattet = new DateExtended(orderline.startDate).format("[DD].[MM].[YYYY] kl. [HH]:[mm]");

                $ctrl.orderlines.push(orderline);
              })
            }
          })
        });

        $ctrl.orderlines.sort(dynamicSort("startDate"));
        $ctrl.products = orderDetails;
        $ctrl.orders = ordersObj;
        $ctrl.loading = false;

        $scope.$apply();
      },
        function (error) {
          console.log("error", error);

          $ctrl.orders = ordersObj;
          $ctrl.loading = false;
        });
    }

    $ctrl.$onInit = function () {
      Orders.getCurrentUsersOrder().then(function (ordersObj) {
        $ctrl.orders = ordersObj;

        $ctrl.fetchOrder()


      }, function (errorResponse) { });
    }
  }
});
